import Button from "devextreme-react/button";
import { useContext, useState } from "react";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext";
import { apiGeneratePurchaseOrderReport } from "../api/get-purchase-order-report";
import { Buffer } from 'buffer';
import { showErrorMessage } from "../../../../utils/messages";
import { LoadPagePanel } from "../../../../components";
import saveAs from 'file-saver';

export default function PrintButton() {

	const { order } = useContext(PurchaseOrderContext);

	let [loading, setLoading] = useState(false);

	return (
		<>
			<Button
				text="Print"
				icon="Inscyth-Print"
				onClick={() => {
					setLoading(true);

					apiGeneratePurchaseOrderReport(order.details.purchaseOrderID, order.details.poNumber)
						.then((result) => {
							if (result.isSuccess) {
								const file = new Blob(
									[new Uint8Array(Buffer.from(result.data, "base64"))],
									{ type: 'application/pdf' }
								);
								saveAs.saveAs(file, `${order.details.poNumber}.pdf`);
							}
							else {
								showErrorMessage(result.errorMessage!);
							}
						})
						.catch((reason) => {
							showErrorMessage(reason);
						})
						.finally(() => { setLoading(false); });
				}}>
			</Button>
			<LoadPagePanel visible={loading} />
		</>
	)
}
